import React from 'react';
import styles from './NotificationItem.module.scss';
import { ReactSVG } from 'react-svg';
import notificationMiningIcon from '../../assets/icon_notification_mining.svg';
import notificationWalletIcon from '../../assets/icon_notification_wallet.svg';
import notificationMessageIcon from '../../assets/icon_notification_message.svg';
import { Notification, getNotificationBody, getNotificationTitle } from '../../domain/Notification';
import { IntlShape } from 'react-intl';
import { getTimeAgo } from '../../utility/numbers/time';
import cx from 'classnames';

type Props = {
  intl: IntlShape;
  notification: Notification;
  onOpen?: () => void;
  compactMode?: boolean;
};

const NotificationItem = ({ intl, notification, onOpen, compactMode }: Props) => {
  return (
    <div
      className={cx(styles.notificationItem, compactMode && styles.compactMode)}
      key={`notification_${notification.id}`}
    >
      <div className={styles.notificationItemContentContainer}>
        <div className={styles.notificationIconContainer}>
          <ReactSVG
            src={
              notification.type === 'job_finished'
                ? notificationMiningIcon
                : notification.type === 'wallet'
                ? notificationWalletIcon
                : notificationMessageIcon
            }
            className={styles.centeredIcon}
          />
        </div>
        <div className={styles.contentContainer}>
          <div className={styles.notificationHeaderContainer}>
            <div className={styles.notificationTitle}>{getNotificationTitle(intl, notification)}</div>
            {!!notification.contentJson.label && (
              <div
                className={styles.notificationLabel}
                style={
                  !!notification.contentJson.labelColor ? { backgroundColor: notification.contentJson.labelColor } : {}
                }
              >
                {notification.contentJson.label}
              </div>
            )}
          </div>
          {getNotificationBody(intl, notification) !== null && (
            <div
              className={styles.notificationBody}
              dangerouslySetInnerHTML={{ __html: getNotificationBody(intl, notification) ?? '' }}
            />
          )}
          <div className={styles.bottomContainer}>
            {onOpen !== undefined && (
              <button className={styles.actionButton} onClick={onOpen}>
                Open
              </button>
            )}
            <div className={styles.notificationTime}>{getTimeAgo(notification.createdAt)}</div>
          </div>
        </div>
      </div>
      {!compactMode && <div className={styles.line} />}
    </div>
  );
};

export default NotificationItem;
